<template>
    <LoadingButton
        v-tooltip="tooltip"
        :loading="addingToCart"
        class="btn btn-xl btn-image"
        :class="{'fade-4': isSizeUnavailable}"
        @click.native="buy">
        <span v-show="!addingToCart">
            &nbsp;{{ text }}
        </span>
    </LoadingButton>
</template>

<script>
    import LoadingButton from "../common/LoadingButton";
    import {cartStore} from "../../common/store/cart-store";
    import {productStore} from "../../common/store/product-store";

    export default {
        name: "ProductBuyButton",

        components: {LoadingButton},

        props: {
            product: {
                type: Object,
                required: true
            },
            sizeToBuy: Object,
            wholesalerSizesQuantitiesToBuy: Object,
            disableTooltip: Boolean,
            isSizeUnavailable: Boolean,
            text: {
                type: String,
                default: 'Comprar'
            }
        },

        data() {
            return {
                productStoreState: productStore.state,
                cartStoreState: cartStore.state,
            }
        },

        computed: {
            addingToCart() {
                return this.cartStoreState.updatingCart;
            },

            price() {
                return this.product.price_min > 0 ? this.product.price_min : this.product.price;
            },

            hasSelectedSize() {
                if (this.$scope.IS_REGULAR_CUSTOMER) {
                    return this.sizeToBuy !== null;
                } else {
                    for (const variationId in this.wholesalerSizesQuantitiesToBuy) {
                        if (this.wholesalerSizesQuantitiesToBuy.hasOwnProperty(variationId)
                            && this.wholesalerSizesQuantitiesToBuy[variationId] > 0) return true;
                    }

                    return false;
                }
            },

            tooltip() {
                if (!this.disableTooltip && !this.hasSelectedSize) {
                    return this.product.is_clothing
                        ? 'Selecione a opção desejada nos campos acima'
                        : 'Selecione o tamanho desejado';
                } else if (this.isSizeUnavailable) {
                    return `A cor ${this.sizeToBuy.product_color_name} não está disponível.`;
                }

                return null;
            }
        },

        methods: {
            buy() {
                if (this.hasSelectedSize && !this.isSizeUnavailable) {
                    this.reportToTagManager();
                    this.addToCart();
                } else {
                    this.$emit('request-size');
                }
            },

            reportToTagManager() {
                let reportItems = [];

                if (!this.$scope.IS_REGULAR_CUSTOMER) {
                    for (let variationId in this.wholesalerSizesQuantitiesToBuy) {
                        if (!this.wholesalerSizesQuantitiesToBuy.hasOwnProperty(variationId)
                            || this.wholesalerSizesQuantitiesToBuy[variationId] <= 0)
                            continue;

                        variationId = parseInt(variationId);
                        const variation = this.product.variations.find(i => i.variation_id === variationId);
                        const variationInfo = this.buildEventVariationInfo(variation);
                        window.dataLayer.push(this.buildCartProductEvent(variationInfo));
                        reportItems.push(this.buildCartEventItem(variationInfo, this.wholesalerSizesQuantitiesToBuy[variationId]));
                    }
                } else {
                    const variationInfo = this.buildEventVariationInfo(this.sizeToBuy);
                    window.dataLayer.push(this.buildCartProductEvent(variationInfo));
                    reportItems.push(this.buildCartEventItem(variationInfo));
                }

                window.dataLayer.push({
                    event: 'addToCart',
                    ecommerce: {
                        currencyCode: 'BRL',
                        add: {products: reportItems}
                    }
                });
            },

            buildEventVariationInfo(variation) {
                const info = {};

                info.sizeName = variation.size_name === 'Único' ? 'Padrão' : variation.size_name;

                switch (variation.gender) {
                    case 'M':
                        info.genderName = 'Masculino';
                        break;
                    case 'F':
                        info.genderName = 'Feminino';
                        break;
                    case 'U':
                        info.genderName = 'Unisex';
                        break;
                    case 'I':
                        info.genderName = 'Infantil';
                        break;
                    default:
                        info.genderName = '';
                }

                info.colorName = variation.product_color_name;

                return info;
            },

            buildCartProductEvent(sizeInfo) {
                return {
                    event: 'addToCartProduct',
                    'product-size-name': sizeInfo.sizeName,
                    'product-gender-name': sizeInfo.genderName
                }
            },

            buildCartEventItem(variationInfo, quantity = 1) {
                const reportProduct = {
                    name: this.product.name,
                    id: `${this.product.id}`,
                    price: `${this.price}`,
                    brand: 'Chico Rei',
                    category: this.category,
                    quantity
                };

                reportProduct.variant = `${variationInfo.genderName}-${variationInfo.sizeName}-${variationInfo.colorName}`.replace('--', '-').replace(/-$/, '').replace(/^-/, '');

                return reportProduct;
            },

            getCartBodyRequest() {
                const products = [];
                if (!this.$scope.IS_REGULAR_CUSTOMER) {
                    for (const variationId in this.wholesalerSizesQuantitiesToBuy) {
                        if (!this.wholesalerSizesQuantitiesToBuy.hasOwnProperty(variationId)
                            || this.wholesalerSizesQuantitiesToBuy[variationId] <= 0)
                            continue;

                        products.push({
                            product_id: this.product.id,
                            variation_id: variationId,
                            quantity: this.wholesalerSizesQuantitiesToBuy[variationId]
                        });
                    }
                } else {
                    products.push({
                        product_id: this.product.id,
                        variation_id: this.sizeToBuy.variation_id,
                        quantity: 1
                    });
                }

                const data = new FormData();
                data.append('json', '1');
                data.append('products', JSON.stringify(products));
                return data;
            },

            addToCart() {
                this.$emit('busy');
                cartStore
                    .addProduct(this.getCartBodyRequest())
                    .then((response) => {
                        this.$scope.cart_id = response.data.cart_id;
                        this.$emit('done');
                    })
                    .catch(() => {
                        this.$emit('fail');
                        this.alert = {
                            message: 'Não foi possível adicionar este produto à sua compra. Tente mais tarde ou entre em contato conosco.',
                            isError: true
                        }
                    });
            }
        }
    }
</script>